// إعدادات مشتركة بين كل الأجهزة
// شوية إعدادات كانت محفوظة في المتصفح (localStorage) على كل جهاز لوحده.
// دلوقتي بتتحفظ على السيرفر (/api/app-settings) وبتنزل على أي جهاز يدخل،
// والشاشات نفسها لسه بتقرا وتكتب في localStorage زي ما هي من غير أي تغيير.

const SHARED_KEYS = [
    'passportDefaultSettings',            // الإعدادات الافتراضية لنموذج الجواز
    'passportWarningSettings',            // تحذيرات وإشعارات الجوازات
    'testsPassportConvertDefaultSettings',// إعدادات التحويل من الاختبارات للجوازات
    'minBalanceAmount',                   // الحد الأدنى للرصيد في الاختيار والتجهيزات
    'allowProcessedManualSelection',
    'qualificationLevels',                // قوائم المؤهلات في الموارد البشرية
    'qualificationSpecializations',
    'scheduledDeactivation',
    'companySettings',                    // نسخة من إعدادات عمولات الشركات
];
const PREFIX = 'ls.';
const isShared = (key) => SHARED_KEYS.includes(key);

let installed = false;
let applying = false;
const pending = new Map();
let timer = null;

const push = () => {
    timer = null;
    const items = [...pending.entries()];
    pending.clear();
    for (const [key, value] of items) {
        fetch(`/api/app-settings/${encodeURIComponent(PREFIX + key)}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ value })
        }).catch(() => {});
    }
};
const queue = (key, value) => {
    pending.set(key, value);
    if (!timer) timer = setTimeout(push, 400);
};

// أي كتابة لمفتاح مشترك بتتبعت للسيرفر كمان
export const installSharedSettingsSync = () => {
    if (installed || typeof window === 'undefined' || !window.localStorage) return;
    installed = true;
    const proto = Object.getPrototypeOf(window.localStorage);
    const origSet = proto.setItem;
    const origRemove = proto.removeItem;
    proto.setItem = function (key, value) {
        origSet.call(this, key, value);
        if (this === window.localStorage && !applying && isShared(key)) queue(key, String(value));
    };
    proto.removeItem = function (key) {
        origRemove.call(this, key);
        if (this === window.localStorage && !applying && isShared(key)) queue(key, null);
    };
};

// بعد الدخول: بنجيب الإعدادات من السيرفر ونحطها في المتصفح قبل ما الشاشات تفتح.
// لو إعداد لسه مش على السيرفر وموجود على الجهاز ده، بيترفع (أول جهاز بيعبّيه للباقي).
export const hydrateSharedSettings = async () => {
    try {
        const r = await fetch('/api/app-settings');
        if (!r.ok) return;
        const data = await r.json();
        const server = (data && data.settings) || {};
        applying = true;
        try {
            for (const key of SHARED_KEYS) {
                const k = PREFIX + key;
                if (Object.prototype.hasOwnProperty.call(server, k)) {
                    const v = server[k];
                    if (v === null || v === undefined) window.localStorage.removeItem(key);
                    else window.localStorage.setItem(key, typeof v === 'string' ? v : JSON.stringify(v));
                } else {
                    const local = window.localStorage.getItem(key);
                    if (local !== null) queue(key, local);
                }
            }
        } finally {
            applying = false;
        }
    } catch {
        // من غير اتصال: الشاشات بتشتغل بالموجود على الجهاز
    }
};
